<template>
  <Teleport to="body">
    <Transition name="fade">
      <div
        v-if="show"
        class="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
        @click.self="$emit('close')"
      >
        <Transition name="pop" appear>
          <div class="bg-white rounded-2xl max-w-sm w-full p-6 shadow-2xl text-center">
            <!-- Ícone de sucesso -->
            <div
              class="mx-auto w-16 h-16 rounded-full flex items-center justify-center mb-4"
              :style="{ backgroundColor: companyStore.primaryColor + '20' }"
            >
              <CheckCircleIcon class="w-10 h-10" :style="{ color: companyStore.primaryColor }" />
            </div>

            <h3 class="text-lg font-bold text-gray-900 mb-1">
              Produto adicionado ao seu pedido
            </h3>
            <p class="text-sm text-gray-600 mb-6">
              {{ quantity }}x {{ productName }}
            </p>

            <div class="flex flex-col gap-2">
              <button
                @click="goToCart"
                class="w-full px-4 py-2.5 text-white rounded-lg font-medium transition-opacity hover:opacity-90 flex items-center justify-center gap-2"
                :style="{ backgroundColor: companyStore.primaryColor }"
              >
                <ShoppingCartIcon class="w-5 h-5" />
                Ir para o carrinho
              </button>
              <button
                @click="$emit('close')"
                class="w-full px-4 py-2.5 bg-white text-gray-700 border border-gray-300 rounded-lg font-medium hover:bg-gray-50 transition-colors"
              >
                Continuar comprando
              </button>
            </div>
          </div>
        </Transition>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { CheckCircleIcon, ShoppingCartIcon } from '@heroicons/vue/24/outline'
import { useCompanyStore } from '@/stores'

defineProps<{
  show: boolean
  productName: string
  quantity: number
}>()

const emit = defineEmits<{
  close: []
}>()

const router = useRouter()
const companyStore = useCompanyStore()

const goToCart = () => {
  emit('close')
  router.push({ name: 'cart' })
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.pop-enter-active {
  transition: transform 0.2s ease, opacity 0.2s ease;
}
.pop-enter-from {
  transform: scale(0.95);
  opacity: 0;
}
</style>
